function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default (function () {
  window.requestAnimationFrame(_loop);
});
var CONSTANTS = {
  articleSelector: '.o-article[id]',
  sidebarLinkActiveClass: 'o-sidebar__link--active'
};
var _loop = function loop() {
  var offsetPixels = 10 * parseFloat(getComputedStyle(document.documentElement).fontSize);
  var inViewportArticleList = _toConsumableArray(document.querySelectorAll("".concat(CONSTANTS.articleSelector))).filter(function (article) {
    var bbox = article.getBoundingClientRect();
    return bbox.top + bbox.height - offsetPixels >= 0 && bbox.top - offsetPixels <= window.innerHeight;
  });
  var inViewportArticleVisibleHeightList = inViewportArticleList.map(function (article) {
    var bbox = article.getBoundingClientRect();
    var maxTop = Math.max(0, bbox.top - offsetPixels);
    var minBottom = Math.min(window.innerHeight, bbox.top + bbox.height - offsetPixels);
    return (minBottom - maxTop) / bbox.height;
  });
  var visibleArticleIndex = inViewportArticleVisibleHeightList.indexOf(Math.max.apply(Math, _toConsumableArray(inViewportArticleVisibleHeightList)));
  var visibleArticle = inViewportArticleList[visibleArticleIndex];
  if (visibleArticle) {
    var activeLink = document.querySelector(".".concat(CONSTANTS.sidebarLinkActiveClass, ":not([href=\"#").concat(visibleArticle.id, "\"])"));
    if (activeLink) activeLink.classList.remove(CONSTANTS.sidebarLinkActiveClass);
    document.querySelector("[href=\"#".concat(visibleArticle.id, "\"]")).classList.add(CONSTANTS.sidebarLinkActiveClass);
  }
  ;
  window.requestAnimationFrame(_loop);
};